import { Plus, X } from "lucide-react";
import { useChatsStore } from "../../store/chats";
import { cn } from "../../lib/cn";

export function SessionTabs() {
  const sessions = useChatsStore((s) => s.sessions);
  const activeId = useChatsStore((s) => s.activeId);
  const switchChat = useChatsStore((s) => s.switchChat);
  const createChat = useChatsStore((s) => s.createChat);
  const deleteChat = useChatsStore((s) => s.deleteChat);

  return (
    <div className="flex items-center gap-0.5 overflow-x-auto px-2 py-1 border-b border-border/50 bg-bg/80 backdrop-blur-sm">
      {sessions.map((s) => {
        const active = s.id === activeId;
        const streaming = s.status === "streaming";
        return (
          <button
            key={s.id}
            onClick={() => switchChat(s.id)}
            className={cn(
              "group relative flex items-center gap-1.5 px-3 py-1.5 rounded-t-lg text-small whitespace-nowrap transition-colors max-w-[180px]",
              active
                ? "bg-bg-subtle text-fg border border-b-0 border-border/60"
                : "text-fg-muted hover:text-fg hover:bg-bg-subtle/40",
            )}
          >
            {streaming && (
              <span className="size-2 rounded-full bg-accent-500 animate-pulse shrink-0" />
            )}
            <span className="truncate">{s.title}</span>
            {sessions.length > 1 && (
              <span
                onClick={(e) => { e.stopPropagation(); deleteChat(s.id); }}
                className="opacity-0 group-hover:opacity-100 ml-1 p-0.5 hover:text-red-400 transition-opacity"
              >
                <X className="size-3" />
              </span>
            )}
          </button>
        );
      })}
      <button
        onClick={() => createChat()}
        className="p-1.5 rounded-md text-fg-muted hover:text-fg hover:bg-bg-subtle transition-colors"
        aria-label="Новая сессия"
      >
        <Plus className="size-4" />
      </button>
    </div>
  );
}
